<rt-dropdown [style.max-width]="width" (click)="$event.preventDefault()">
  <div *ngIf="hasSearch" class="header">
    <rt-form-field variant="underlined search">
      <rt-icon [name]="'search'"> </rt-icon>
      <rt-input
        #input
        (keydown.esc)="keydownEscape($event)"
        [disableInvalidStyles]="true"
        [autoFocus]="true"
        [formControl]="control"
        [placeholder]="text && text.placeholder"
        [hasClearButton]="true"
        [loading]="loading"
        (reset)="control.reset()"
        variant="underlined large"
      >
      </rt-input>
    </rt-form-field>
  </div>

  <rt-attributes-select-list
    *ngIf="suggestions.rows.length > 0"
    [maxHeight]="maxDropdownHeight"
    [suggestionsListData]="suggestions"
    [createNewItemId]="CREATE_NEW_ITEM_ID"
    [createNewAttr]="createNewAttr"
    [highlightedId]="state.highlighted && state.highlighted.id"
    (saveAttribute)="onSaveAttribute($event, 'suggestion')"
    (loadMore)="onLoadMore()"
  >
  </rt-attributes-select-list>

  <rt-experimental-dropdown-item
    *ngIf="state.errors && state.errors.maxlength"
    [raw]="true"
    [label]="maxLengthExceeded"
  >
  </rt-experimental-dropdown-item>

  <ng-container *ngIf="!showAlreadyExists && control.valid">
    <rt-experimental-dropdown-item
      *ngIf="suggestions.rows.length === 0 && state.preventCreateMessageVisible && !createDisabled"
      [raw]="true"
      [label]="emptyResultsWithNoAbilityToCreateNewWithValue"
    >
    </rt-experimental-dropdown-item>

    <rt-experimental-dropdown-item
      *ngIf="suggestions.rows.length === 0 && state.preventCreateMessageVisible && createDisabled"
      [raw]="true"
      [label]="emptyResultsWithCreatingDisabled"
    >
    </rt-experimental-dropdown-item>

    <rt-experimental-dropdown-item
      *ngIf="suggestions.rows.length > 0 && state.preventCreateMessageVisible && !createDisabled"
      [raw]="true"
      [label]="nonEmptyResultsWithNoAbilityToCreateNew"
    >
    </rt-experimental-dropdown-item>

    <rt-experimental-dropdown-item
      *ngIf="!state.preventCreateMessageVisible && suggestions.rows.length === 0 && !canCreate"
      [raw]="true"
      [label]="emptyResultsWithNoAbilityToCreateNew"
    >
    </rt-experimental-dropdown-item>

    <rt-experimental-dropdown-item
      *ngIf="suggestions.rows.length === 0 && canCreate"
      (click)="onSaveAttribute({ value: control.value }, 'input')"
      [raw]="true"
      [label]="createNewAttr"
    >
    </rt-experimental-dropdown-item>
  </ng-container>

  <rt-experimental-dropdown-item *ngIf="showAlreadyExists" [raw]="true" [label]="attrAlreadyExists">
  </rt-experimental-dropdown-item>

  <ng-template [ngIf]="selectFooterTemplate" [ngTemplateOutlet]="selectFooterTemplate">
  </ng-template>
</rt-dropdown>

<ng-template #maxLengthExceeded>
  <div class="special-item with-padding">
    <div class="head">{{ text.maxLengthExceeded }}</div>
  </div>
</ng-template>

<ng-template #nonEmptyResultsWithNoAbilityToCreateNew>
  <div class="special-item with-padding">
    <div class="head">"{{ control.value }}" {{ text.notFound }}</div>
    <div class="value">{{ text.noAbilityToCreateAttr }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithNoAbilityToCreateNewWithValue>
  <div class="special-item highlight-value">
    <div class="head">{{ text.noAbilityToCreateAttr }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithNoAbilityToCreateNew>
  <div class="special-item with-padding">
    <div class="head">{{ text.emptyResults }}</div>
    <div class="value">{{ text.noAbilityToCreateAttr }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithCreatingDisabled>
  <div class="special-item with-padding">
    <div class="head">{{ text.emptyResults }}</div>
  </div>
</ng-template>

<ng-template #attrAlreadyExists>
  <div class="special-item">
    <div class="head">{{ text.attrAlreadyExists }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>

<ng-template #createNewAttr>
  <div class="special-item highlight-value clickable">
    <div class="head">{{ text.createNewAttr }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>
